import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const useScrollTopOnRouteChange = (): void => {
  const history = useNavigate()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [history])
}
